// Part of taxPages, split to keep files short; ../taxPages.ts merges the parts. Keys sit directly under taxPages.
export const en = {
  emirates: {
    abuDhabi: 'Abu Dhabi',
    dubai: 'Dubai',
    sharjah: 'Sharjah',
    ajman: 'Ajman',
    ummAlQuwain: 'Umm Al Quwain',
    rasAlKhaimah: 'Ras Al Khaimah',
    fujairah: 'Fujairah',
  },
  vatBoxes: {
    b1a: 'Standard rated supplies in Abu Dhabi',
    b1b: 'Standard rated supplies in Dubai',
    b1c: 'Standard rated supplies in Sharjah',
    b1d: 'Standard rated supplies in Ajman',
    b1e: 'Standard rated supplies in Umm Al Quwain',
    b1f: 'Standard rated supplies in Ras Al Khaimah',
    b1g: 'Standard rated supplies in Fujairah',
    b2: 'Tax refunds provided to tourists under the tax refunds for tourists scheme',
    b3: 'Supplies subject to the reverse charge provisions',
    b4: 'Zero rated supplies',
    b5: 'Supplies of goods and services which are exempt from VAT',
    b6: 'Goods imported into the UAE',
    b7: 'Adjustments to goods imported into the UAE',
    b8: 'Totals',
    b9: 'Standard rated expenses',
    b10: 'Supplies subject to the reverse charge provisions',
    b11: 'Totals',
    b12: 'Total value of due tax for the period',
    b13: 'Total value of recoverable tax for the period',
    b14: 'Payable tax for the period',
  },
  vatShared: {
    title: 'VAT',
    trnLabel: 'TRN',
    trnValue: 'TRN {{trn}}',
    filingFrequency: 'Filing frequency',
    monthly: 'Monthly',
    quarterly: 'Quarterly',
    periodRange: '{{from}} to {{to}}',
    dueOn: 'Due {{date}}',
    netVatRefundable: 'Net VAT refundable',
    netVatPayable: 'Net VAT payable',
    recordRefund: 'Record refund',
    recordPayment: 'Record payment',
  },
  vatHome: {
    description: 'VAT returns for each tax period, from the books.',
    loadError: 'Could not load VAT returns',
    notRegisteredTitle: 'This client is not registered for VAT',
    notRegisteredHint:
      'Add the TRN and registration date in Company settings to start preparing VAT returns.',
    companySettings: 'Company settings',
    quarterlyFromJanuary: 'Quarterly, first quarter starting in January',
    quarterlyFromFebruary: 'Quarterly, first quarter starting in February',
    quarterlyFromMarch: 'Quarterly, first quarter starting in March',
    registeredSince: 'Registered since',
    filedAndPaid: 'Filed and paid',
    noPaidReturns: 'No paid returns yet.',
    colPeriod: 'Period',
    colFiled: 'Filed',
    colDue: 'Due',
    colNetVat: 'Net VAT',
    colStatus: 'Status',
    colAction: 'Action',
    viewReturn: 'View return',
    viewRunningTotals: 'View running totals',
    prepareReturn: 'Prepare return',
    vatOnSales: 'VAT on sales',
    vatOnPurchases: 'VAT on purchases',
    runningTotals: 'Running totals for the period so far.',
    exceptionsToReview_one: '{{count}} exception to review',
    exceptionsToReview_other: '{{count}} exceptions to review',
  },
  vatSettings: {
    description: 'Filing frequency and the checks run before filing.',
    saved: 'VAT settings saved.',
    loadError: 'Could not load VAT settings',
    registration: 'Registration',
    vatRegistered: 'VAT registered',
    effectiveDate: 'Effective date',
    emirate: 'Emirate',
    registrationKept:
      'Registration details are kept in <lnk>Company settings</lnk>. The emirate is the place of supply when a customer has none.',
    periodsAndChecks: 'Tax periods and checks',
    frequencyHint: 'As assigned by the FTA.',
    quarters: 'Quarters',
    quartersHint: 'The FTA staggers quarterly periods.',
    stagger1: 'Jan–Mar, Apr–Jun, Jul–Sep, Oct–Dec',
    stagger2: 'Feb–Apr, May–Jul, Aug–Oct, Nov–Jan',
    stagger3: 'Mar–May, Jun–Aug, Sep–Nov, Dec–Feb',
    largePurchase: 'Large purchase without TRN ({{currency}})',
    largePurchaseHint:
      "Purchases above this claiming input VAT without the supplier's TRN are listed as exceptions.",
    disclosure: 'Voluntary disclosure flag ({{currency}})',
    disclosureHint: 'A filed return whose figures later change by more than this is flagged.',
    frequencyNote:
      'Returns already filed keep their periods when the frequency changes; new periods start the day after the last one. Currently flagged above {{large}} and {{disclosure}}.',
  },
  vatReturn: {
    sectionSales: 'VAT on sales and all other outputs',
    sectionExpenses: 'VAT on expenses and all other inputs',
    sectionNet: 'Net VAT due',
    loadError: 'Could not load the VAT return',
    backToVat: 'Back to VAT',
    heading: 'VAT return {{label}}',
    exportCsv: 'Export to Excel (CSV)',
    csvFileName: 'VAT return {{label}}.csv',
    print: 'Print',
    addAdjustment: 'Add adjustment',
    markAsFiled: 'Mark as filed',
    moreActions: 'More actions',
    more: 'More',
    reopenReturn: 'Reopen return',
    vatOnSalesBox: 'VAT on sales (box 12)',
    vatOnPurchasesBox: 'VAT on purchases (box 13)',
    refunded: 'Refunded',
    paid: 'Paid',
    outstandingHint: '{{amount}} outstanding',
    filedOn: 'Filed on {{date}}',
    filedOnBy: 'Filed on {{date}} by <b>{{name}}</b>',
    ftaReference: 'FTA reference {{reference}}',
    returnJournal: 'VAT return journal <lnk>no. {{no}}</lnk>',
    lockedNote: 'VAT in this period is locked; date corrections in an open period.',
    runningNote:
      'The period is still running: these are the totals so far. The return can be filed after {{date}}.',
    changedSinceFiling:
      'The books now give different figures for this period than the filed return. The filed figures are shown; see the exceptions below.',
    adjustmentsNote:
      'Adjustments change the return only. Net VAT in the books for this period is {{amount}}; post a journal entry for the effect of the adjustments on the VAT accounts.',
    colBox: 'Box',
    colDescription: 'Description',
    colAmountCurrency: 'Amount ({{currency}})',
    colVatCurrency: 'VAT ({{currency}})',
    colAdjustment: 'Adjustment',
    adjAmount: 'Amount {{amount}}',
    adjVat: 'VAT {{amount}}',
    adjustmentsTitle: 'Adjustments ({{count}})',
    noAdjustments:
      'No adjustments. Use them for tourist refunds (box 2), import adjustments (box 7), bad debt relief and other corrections the books do not carry; each needs a reason.',
    exceptionsTitle: 'Exceptions',
    exceptionsTitleCount: 'Exceptions ({{count}})',
    exceptionsHint: "Checks on this period's transactions. They do not change the boxes.",
    checking: 'Checking…',
    noExceptions: 'No exceptions found.',
    error: 'Error',
    warning: 'Warning',
    entryNo: 'no. {{no}}',
    refunds: 'Refunds',
    payments: 'Payments',
    nothingToPay: 'Nothing to pay.',
    nothingRecorded: 'Nothing recorded yet.',
    colDate: 'Date',
    colType: 'Type',
    colAccount: 'Account',
    colReference: 'Reference',
    colJournal: 'Journal',
    colAmount: 'Amount',
    colReason: 'Reason',
    colBy: 'By',
    colVat: 'VAT',
    paymentToFta: 'Payment to FTA',
    refundFromFta: 'Refund from FTA',
    adjustmentRemoved: 'Adjustment removed.',
    removeAdjustment: 'Remove adjustment to box {{box}}',
    markedFiled: 'VAT return {{label}} marked as filed.',
    viewJournal: 'View journal',
    fileTitle: 'Mark VAT return {{label}} as filed?',
    fileDescriptionPayable:
      'The box figures are stored as filed and VAT in {{from}} to {{to}} is locked: transactions with VAT can no longer be dated in this period. Net VAT payable: {{amount}}.',
    fileDescriptionRefundable:
      'The box figures are stored as filed and VAT in {{from}} to {{to}} is locked: transactions with VAT can no longer be dated in this period. Net VAT refundable: {{amount}}.',
    exceptionsStillListed_one: '{{count}} exception is still listed for this period.',
    exceptionsStillListed_other: '{{count}} exceptions are still listed for this period.',
    dateFiled: 'Date filed',
    ftaReferenceOptional: 'FTA reference (optional)',
    ftaReferenceHint: 'The acknowledgement number from the FTA portal.',
    postJournal: 'Post the VAT return journal (moves output and input VAT to VAT control)',
    filing: 'Filing…',
    refundRecorded: 'VAT refund recorded.',
    paymentRecorded: 'VAT payment recorded.',
    recordVatRefund: 'Record VAT refund',
    recordVatPayment: 'Record VAT payment',
    refundDescription:
      'Posts the refund from the FTA: bank account debited, VAT control credited. Outstanding on this return: {{amount}}.',
    paymentDescription:
      'Posts the payment to the FTA: VAT control debited, bank account credited. Outstanding on this return: {{amount}}.',
    date: 'Date',
    bankAccount: 'Bank account',
    amountCurrency: 'Amount ({{currency}})',
    vatCurrency: 'VAT ({{currency}})',
    referenceOptional: 'Reference (optional)',
    referenceHint: 'For example the e-Dirham or bank transfer number.',
    reopened: 'VAT return {{label}} reopened.',
    reopenTitle: 'Reopen VAT return {{label}}?',
    reopenDescription:
      'The filed figures are discarded, the VAT return journal is reversed today and VAT in the period is unlocked. Use this only when the return has not been submitted to the FTA, or before a correction is refiled. The reason is kept in the audit log.',
    reason: 'Reason',
    adjustmentAdded: 'Adjustment to box {{box}} added.',
    adjustDescription:
      'Changes a box on this return without posting to the books. Every adjustment needs a reason and is kept in the audit log.',
    box: 'Box',
    direction: 'Direction',
    decreaseBox: 'Decrease the box',
    increaseBox: 'Increase the box',
  },
};

export const ar = {
  emirates: {
    abuDhabi: 'أبوظبي',
    dubai: 'دبي',
    sharjah: 'الشارقة',
    ajman: 'عجمان',
    ummAlQuwain: 'أم القيوين',
    rasAlKhaimah: 'رأس الخيمة',
    fujairah: 'الفجيرة',
  },
  vatBoxes: {
    b1a: 'التوريدات الخاضعة للنسبة الأساسية في أبوظبي',
    b1b: 'التوريدات الخاضعة للنسبة الأساسية في دبي',
    b1c: 'التوريدات الخاضعة للنسبة الأساسية في الشارقة',
    b1d: 'التوريدات الخاضعة للنسبة الأساسية في عجمان',
    b1e: 'التوريدات الخاضعة للنسبة الأساسية في أم القيوين',
    b1f: 'التوريدات الخاضعة للنسبة الأساسية في رأس الخيمة',
    b1g: 'التوريدات الخاضعة للنسبة الأساسية في الفجيرة',
    b2: 'المبالغ المستردة للسياح وفق نظام استرداد الضريبة للسياح',
    b3: 'التوريدات الخاضعة لأحكام الاحتساب العكسي',
    b4: 'التوريدات الخاضعة لنسبة الصفر',
    b5: 'التوريدات المعفاة',
    b6: 'السلع المستوردة إلى الدولة',
    b7: 'التعديلات على السلع المستوردة إلى الدولة',
    b8: 'الإجمالي',
    b9: 'النفقات الخاضعة للنسبة الأساسية',
    b10: 'التوريدات الخاضعة لأحكام الاحتساب العكسي',
    b11: 'الإجمالي',
    b12: 'إجمالي الضريبة المستحقة عن الفترة الضريبية',
    b13: 'إجمالي الضريبة القابلة للاسترداد عن الفترة الضريبية',
    b14: 'الضريبة المستحقة الدفع عن الفترة الضريبية',
  },
  vatShared: {
    title: 'ضريبة القيمة المضافة',
    trnLabel: 'رقم التسجيل الضريبي',
    trnValue: 'رقم التسجيل الضريبي {{trn}}',
    filingFrequency: 'دورية تقديم الإقرار',
    monthly: 'شهري',
    quarterly: 'ربع سنوي',
    periodRange: 'من {{from}} إلى {{to}}',
    dueOn: 'الاستحقاق {{date}}',
    netVatRefundable: 'صافي الضريبة القابلة للاسترداد',
    netVatPayable: 'صافي الضريبة المستحقة الدفع',
    recordRefund: 'تسجيل الاسترداد',
    recordPayment: 'تسجيل الدفعة',
  },
  vatHome: {
    description: 'إقرارات ضريبة القيمة المضافة لكل فترة ضريبية، من واقع الدفاتر.',
    loadError: 'تعذّر تحميل إقرارات ضريبة القيمة المضافة',
    notRegisteredTitle: 'هذا العميل غير مسجَّل في ضريبة القيمة المضافة',
    notRegisteredHint:
      'أضف رقم التسجيل الضريبي وتاريخ التسجيل في إعدادات الشركة لبدء إعداد إقرارات ضريبة القيمة المضافة.',
    companySettings: 'إعدادات الشركة',
    quarterlyFromJanuary: 'ربع سنوي، يبدأ الربع الأول في يناير',
    quarterlyFromFebruary: 'ربع سنوي، يبدأ الربع الأول في فبراير',
    quarterlyFromMarch: 'ربع سنوي، يبدأ الربع الأول في مارس',
    registeredSince: 'مسجَّل منذ',
    filedAndPaid: 'المقدَّمة والمدفوعة',
    noPaidReturns: 'لا توجد إقرارات مدفوعة بعد.',
    colPeriod: 'الفترة',
    colFiled: 'تاريخ التقديم',
    colDue: 'الاستحقاق',
    colNetVat: 'صافي الضريبة',
    colStatus: 'الحالة',
    colAction: 'الإجراء',
    viewReturn: 'عرض الإقرار',
    viewRunningTotals: 'عرض الإجماليات حتى الآن',
    prepareReturn: 'إعداد الإقرار',
    vatOnSales: 'الضريبة على المبيعات',
    vatOnPurchases: 'الضريبة على المشتريات',
    runningTotals: 'إجماليات الفترة حتى الآن.',
    exceptionsToReview_zero: 'لا توجد استثناءات للمراجعة',
    exceptionsToReview_one: 'استثناء واحد للمراجعة',
    exceptionsToReview_two: 'استثناءان للمراجعة',
    exceptionsToReview_few: '{{count}} استثناءات للمراجعة',
    exceptionsToReview_many: '{{count}} استثناءً للمراجعة',
    exceptionsToReview_other: '{{count}} استثناء للمراجعة',
  },
  vatSettings: {
    description: 'دورية تقديم الإقرار والفحوصات التي تُجرى قبل التقديم.',
    saved: 'تم حفظ إعدادات ضريبة القيمة المضافة.',
    loadError: 'تعذّر تحميل إعدادات ضريبة القيمة المضافة',
    registration: 'التسجيل',
    vatRegistered: 'مسجَّل في ضريبة القيمة المضافة',
    effectiveDate: 'تاريخ السريان',
    emirate: 'الإمارة',
    registrationKept:
      'تُحفظ بيانات التسجيل في <lnk>إعدادات الشركة</lnk>. الإمارة هي مكان التوريد عندما لا يكون للعميل إمارة.',
    periodsAndChecks: 'الفترات الضريبية والفحوصات',
    frequencyHint: 'كما حددتها الهيئة الاتحادية للضرائب.',
    quarters: 'الأرباع',
    quartersHint: 'توزّع الهيئة الاتحادية للضرائب الفترات الربع سنوية على مجموعات متتابعة.',
    stagger1: 'يناير–مارس، أبريل–يونيو، يوليو–سبتمبر، أكتوبر–ديسمبر',
    stagger2: 'فبراير–أبريل، مايو–يوليو، أغسطس–أكتوبر، نوفمبر–يناير',
    stagger3: 'مارس–مايو، يونيو–أغسطس، سبتمبر–نوفمبر، ديسمبر–فبراير',
    largePurchase: 'مشتريات كبيرة دون رقم تسجيل ضريبي ({{currency}})',
    largePurchaseHint:
      'المشتريات التي تتجاوز هذا المبلغ وتُطالب فيها بضريبة المدخلات دون رقم التسجيل الضريبي للمورد تُدرج ضمن الاستثناءات.',
    disclosure: 'حد الإفصاح الطوعي ({{currency}})',
    disclosureHint: 'يُنبَّه على الإقرار المقدَّم إذا تغيرت أرقامه لاحقاً بأكثر من هذا المبلغ.',
    frequencyNote:
      'تحتفظ الإقرارات المقدَّمة بفتراتها عند تغيير الدورية؛ وتبدأ الفترات الجديدة في اليوم التالي لآخر فترة. حدود التنبيه الحالية: أكثر من {{large}} و{{disclosure}}.',
  },
  vatReturn: {
    sectionSales: 'ضريبة القيمة المضافة على المبيعات وجميع المخرجات الأخرى',
    sectionExpenses: 'ضريبة القيمة المضافة على النفقات وجميع المدخلات الأخرى',
    sectionNet: 'صافي الضريبة المستحقة',
    loadError: 'تعذّر تحميل إقرار ضريبة القيمة المضافة',
    backToVat: 'العودة إلى ضريبة القيمة المضافة',
    heading: 'إقرار ضريبة القيمة المضافة {{label}}',
    exportCsv: 'تصدير إلى Excel (CSV)',
    csvFileName: 'إقرار ضريبة القيمة المضافة {{label}}.csv',
    print: 'طباعة',
    addAdjustment: 'إضافة تعديل',
    markAsFiled: 'تحديد كمقدَّم',
    moreActions: 'إجراءات أخرى',
    more: 'المزيد',
    reopenReturn: 'إعادة فتح الإقرار',
    vatOnSalesBox: 'الضريبة على المبيعات (الخانة 12)',
    vatOnPurchasesBox: 'الضريبة على المشتريات (الخانة 13)',
    refunded: 'المسترد',
    paid: 'المدفوع',
    outstandingHint: '{{amount}} متبقٍ',
    filedOn: 'قُدِّم في {{date}}',
    filedOnBy: 'قُدِّم في {{date}} بواسطة <b>{{name}}</b>',
    ftaReference: 'مرجع الهيئة {{reference}}',
    returnJournal: 'قيد إقرار ضريبة القيمة المضافة <lnk>رقم {{no}}</lnk>',
    lockedNote:
      'ضريبة القيمة المضافة في هذه الفترة مقفلة؛ تُسجَّل التصحيحات بتاريخ في فترة مفتوحة.',
    runningNote:
      'الفترة ما زالت جارية: هذه هي الإجماليات حتى الآن. يمكن تقديم الإقرار بعد {{date}}.',
    changedSinceFiling:
      'تعطي الدفاتر الآن أرقاماً لهذه الفترة تختلف عن الإقرار المقدَّم. تُعرض الأرقام المقدَّمة؛ راجع الاستثناءات أدناه.',
    adjustmentsNote:
      'تغيّر التعديلات الإقرار فقط. صافي الضريبة في الدفاتر لهذه الفترة {{amount}}؛ سجّل قيد يومية لأثر التعديلات على حسابات ضريبة القيمة المضافة.',
    colBox: 'الخانة',
    colDescription: 'الوصف',
    colAmountCurrency: 'المبلغ ({{currency}})',
    colVatCurrency: 'الضريبة ({{currency}})',
    colAdjustment: 'التعديل',
    adjAmount: 'المبلغ {{amount}}',
    adjVat: 'الضريبة {{amount}}',
    adjustmentsTitle: 'التعديلات ({{count}})',
    noAdjustments:
      'لا توجد تعديلات. استخدمها لاسترداد الضريبة للسياح (الخانة 2) وتعديلات الاستيراد (الخانة 7) وإعفاء الديون المعدومة وغيرها من التصحيحات التي لا تحملها الدفاتر؛ ويحتاج كل تعديل إلى سبب.',
    exceptionsTitle: 'الاستثناءات',
    exceptionsTitleCount: 'الاستثناءات ({{count}})',
    exceptionsHint: 'فحوصات على معاملات هذه الفترة. لا تغيّر الخانات.',
    checking: 'جارٍ الفحص…',
    noExceptions: 'لم يُعثر على استثناءات.',
    error: 'خطأ',
    warning: 'تحذير',
    entryNo: 'رقم {{no}}',
    refunds: 'المبالغ المستردة',
    payments: 'الدفعات',
    nothingToPay: 'لا يوجد مبلغ للدفع.',
    nothingRecorded: 'لم يُسجَّل شيء بعد.',
    colDate: 'التاريخ',
    colType: 'النوع',
    colAccount: 'الحساب',
    colReference: 'المرجع',
    colJournal: 'القيد',
    colAmount: 'المبلغ',
    colReason: 'السبب',
    colBy: 'بواسطة',
    colVat: 'الضريبة',
    paymentToFta: 'دفعة إلى الهيئة الاتحادية للضرائب',
    refundFromFta: 'استرداد من الهيئة الاتحادية للضرائب',
    adjustmentRemoved: 'تمت إزالة التعديل.',
    removeAdjustment: 'إزالة تعديل الخانة {{box}}',
    markedFiled: 'تم تحديد إقرار ضريبة القيمة المضافة {{label}} كمقدَّم.',
    viewJournal: 'عرض القيد',
    fileTitle: 'تحديد إقرار ضريبة القيمة المضافة {{label}} كمقدَّم؟',
    fileDescriptionPayable:
      'تُحفظ أرقام الخانات كما قُدِّمت، وتُقفل ضريبة القيمة المضافة من {{from}} إلى {{to}}: لا يمكن بعد ذلك تأريخ معاملات خاضعة للضريبة في هذه الفترة. صافي الضريبة المستحقة الدفع: {{amount}}.',
    fileDescriptionRefundable:
      'تُحفظ أرقام الخانات كما قُدِّمت، وتُقفل ضريبة القيمة المضافة من {{from}} إلى {{to}}: لا يمكن بعد ذلك تأريخ معاملات خاضعة للضريبة في هذه الفترة. صافي الضريبة القابلة للاسترداد: {{amount}}.',
    exceptionsStillListed_zero: 'لا توجد استثناءات مدرجة لهذه الفترة.',
    exceptionsStillListed_one: 'ما زال هناك استثناء واحد مدرج لهذه الفترة.',
    exceptionsStillListed_two: 'ما زال هناك استثناءان مدرجان لهذه الفترة.',
    exceptionsStillListed_few: 'ما زالت هناك {{count}} استثناءات مدرجة لهذه الفترة.',
    exceptionsStillListed_many: 'ما زال هناك {{count}} استثناءً مدرجاً لهذه الفترة.',
    exceptionsStillListed_other: 'ما زال هناك {{count}} استثناء مدرج لهذه الفترة.',
    dateFiled: 'تاريخ التقديم',
    ftaReferenceOptional: 'مرجع الهيئة (اختياري)',
    ftaReferenceHint: 'رقم الإشعار بالاستلام من بوابة الهيئة الاتحادية للضرائب.',
    postJournal:
      'ترحيل قيد إقرار ضريبة القيمة المضافة (ينقل ضريبة المخرجات وضريبة المدخلات إلى حساب مراقبة ضريبة القيمة المضافة)',
    filing: 'جارٍ التقديم…',
    refundRecorded: 'تم تسجيل استرداد ضريبة القيمة المضافة.',
    paymentRecorded: 'تم تسجيل دفعة ضريبة القيمة المضافة.',
    recordVatRefund: 'تسجيل استرداد ضريبة القيمة المضافة',
    recordVatPayment: 'تسجيل دفعة ضريبة القيمة المضافة',
    refundDescription:
      'يرحّل الاسترداد من الهيئة الاتحادية للضرائب: الحساب البنكي مدين، وحساب مراقبة الضريبة دائن. المتبقي على هذا الإقرار: {{amount}}.',
    paymentDescription:
      'يرحّل الدفعة إلى الهيئة الاتحادية للضرائب: حساب مراقبة الضريبة مدين، والحساب البنكي دائن. المتبقي على هذا الإقرار: {{amount}}.',
    date: 'التاريخ',
    bankAccount: 'الحساب البنكي',
    amountCurrency: 'المبلغ ({{currency}})',
    vatCurrency: 'الضريبة ({{currency}})',
    referenceOptional: 'المرجع (اختياري)',
    referenceHint: 'مثل رقم الدرهم الإلكتروني أو رقم التحويل البنكي.',
    reopened: 'تمت إعادة فتح إقرار ضريبة القيمة المضافة {{label}}.',
    reopenTitle: 'إعادة فتح إقرار ضريبة القيمة المضافة {{label}}؟',
    reopenDescription:
      'تُلغى الأرقام المقدَّمة، ويُعكس قيد إقرار ضريبة القيمة المضافة بتاريخ اليوم، وتُفتح ضريبة القيمة المضافة في الفترة. استخدم هذا فقط إذا لم يُقدَّم الإقرار إلى الهيئة الاتحادية للضرائب، أو قبل إعادة تقديم تصحيح. يُحفظ السبب في سجل التدقيق.',
    reason: 'السبب',
    adjustmentAdded: 'تمت إضافة تعديل على الخانة {{box}}.',
    adjustDescription:
      'يغيّر خانة في هذا الإقرار دون ترحيل إلى الدفاتر. يحتاج كل تعديل إلى سبب ويُحفظ في سجل التدقيق.',
    box: 'الخانة',
    direction: 'الاتجاه',
    decreaseBox: 'تخفيض الخانة',
    increaseBox: 'زيادة الخانة',
  },
};
